import { FC, useCallback, useEffect, useState } from 'react';

import { useGetUser, useIsSelectCarrier } from 'app/api/hooks/core/v1/auth/user';
import { CompanyTypeId } from 'app/constants/user';
import { initFullstory } from 'app/services/fullstory';
import { PropsWithOnlyChildren } from 'app/types';
import { getLanguage } from 'app/utils/lib/i18n';

// Component Definition
const FullStoryProvider: FC<PropsWithOnlyChildren> = ({ children }) => {
  const [isFullStoryLoaded, setIsFullStoryLoaded] = useState(false);

  const user = useGetUser();
  const isSelectCarrier = useIsSelectCarrier();

  const handleIdentifyUser = useCallback(() => {
    if (typeof window.FullStory === 'undefined') {
      return;
    }

    if (user?.id && user.company) {
      window.FullStory.restart();
      window.FullStory.identify(user.id,
        {
          ['Company DOT']: user.company.dotNumber ?? '',
          ['Company ID']: user.company.id ?? '',
          ['Company MC']: user.company.mcNumber ?? '',
          ['Company Name']: user.company.name,
          ['Is Factor']: user.company.type.id as CompanyTypeId === CompanyTypeId.Factor,
          ['Is Select Carrier']: isSelectCarrier,
          ['Profile Type']: user.company.type.name ?? '',
          ['User Locale']: getLanguage(),
          ['User Name']: user.name ?? '',
          ['User Role']: user.roles?.map(role => role.name).join(', ') ?? '',
          displayName: `${user.company.name} - ${user.name}`,
          email: user.email ?? '',
        });
    } else {
      window.FullStory.anonymize();
    }
  },
  [isSelectCarrier, user]);

  useEffect(() => {
    initFullstory();
    setIsFullStoryLoaded(true);
  },
  [setIsFullStoryLoaded]);

  useEffect(() => {
    if (isFullStoryLoaded) {
      handleIdentifyUser();
    }
  },
  [handleIdentifyUser, isFullStoryLoaded]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {children}
    </>
  );
};

export default FullStoryProvider;
